module.exports = __webpack_public_path__ + "media/images/svg/logo_valencia-6346bbcd40abc41a54be52147a484cd6.svg";